import React from "react";
import { useEffect, useRef } from "react";
import useGameStore from "../store/gameStore";
import LeaderboardIcon from "../assets/leaderboard_icon.svg";
import HelpIcon from "../assets/help_icon.svg";

export default function BottomMenu() {
  const leaderboardOpen = useGameStore((s) => s.leaderboardOpen);
  const helpOpen = useGameStore((s) => s.helpOpen);
  const leaderboards = useGameStore((s) => s.leaderboards);
  const toggleLeaderboard = useGameStore((s) => s.toggleLeaderboard);
  const toggleHelp = useGameStore((s) => s.toggleHelp);
  const closeLeaderboard = useGameStore((s) => s.closeLeaderboard);
  const closeHelp = useGameStore((s) => s.closeHelp);

  const leaderboardRef = useRef(null);
  const helpRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        leaderboardRef.current &&
        !leaderboardRef.current.contains(e.target)
      ) {
        closeLeaderboard();
      }
      if (helpRef.current && !helpRef.current.contains(e.target)) {
        closeHelp();
      }
    };

    if (leaderboardOpen || helpOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaderboardOpen, helpOpen]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        maxWidth: "300px",
        paddingTop: "25px",
        position: "relative",
        zIndex: "9",
      }}
    >
      <div style={{ width: "80px", display: "flex", justifyContent: "center" }}>
        {Object.keys(leaderboards).length > 0 && (
          <img
            style={{ cursor: "pointer", height: "80px", width: "80px" }}
            className="leaderboard-icon"
            src={LeaderboardIcon}
            alt="leaderboard"
            onClick={() => {
              toggleLeaderboard();
            }}
            ref={leaderboardRef}
          />
        )}
      </div>
      <div style={{ width: "80px", display: "flex", justifyContent: "center" }}>
        <img
          style={{ cursor: "pointer", height: "80px", width: "80px" }}
          className="help-icon"
          src={HelpIcon}
          alt="help"
          onClick={() => {
            toggleHelp();
          }}
          ref={helpRef}
        />
      </div>
    </div>
  );
}
